function Skill({source, alt, title}) {
    return  <img src={source} alt={alt} title={title}/>
}

export default Skill